import { useState, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import LogoImage from "../assets/Image/Logo.png"

const Header = ({ onHomeClick }) => {
  const [isSticky, setIsSticky] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleOrdersClick = () => {
    window.open("https://mediwhistle.com/user/", "_blank")
    setIsMenuOpen(false)
  }

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev)
  }

  const isProductsPage = location.pathname === "/products"
  const isTipsPage = location.pathname === "/tips"

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isSticky ? "bg-[#1a3324] backdrop-blur-md shadow-md" : "bg-[#1a3324]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Mobile: Centered Logo */}
          <div className="md:hidden flex-1 flex justify-center">
            <button
              onClick={onHomeClick}
              className="flex items-center gap-3 group focus:outline-none"
            >
              <img
                src={LogoImage}
                alt="Mediwhistle Logo"
                className="h-16 object-contain"
              />
            </button>
          </div>

          {/* Desktop: Left-aligned Logo */}
          <div className="hidden md:block">
            <button
              onClick={onHomeClick}
              className="flex items-center gap-3 group focus:outline-none"
            >
              <img
                src={LogoImage}
                alt="Mediwhistle Logo"
                className="h-24 object-contain"
              />
            </button>
          </div>

          {/* Right Side */}
          {!isProductsPage && !isTipsPage && (
            <div className="flex items-center gap-4">
              {/* Desktop Order Button */}
              <div className="hidden md:flex items-center gap-4">
                <button
                  onClick={handleOrdersClick}
                  className="bg-emerald-800 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg font-medium shadow-sm transition"
                >
                  Orders
                </button>
              </div>

              {/* Mobile Hamburger Menu */}
              <button
                onClick={toggleMenu}
                className="md:hidden text-white focus:outline-none"
                aria-label="Toggle menu"
              >
                <svg
                  className="w-6 h-6 transition-transform duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                  />
                </svg>
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        {!isProductsPage && !isTipsPage && (
          <div
            ref={menuRef}
            className={`md:hidden bg-[#1a3324] border-t border-emerald-900 px-4 py-4 overflow-hidden transition-all duration-300 ease-in-out ${
              isMenuOpen
                ? "max-h-96 opacity-100 translate-y-0"
                : "max-h-0 opacity-0 -translate-y-4"
            }`}
          >
            <div className="flex flex-col gap-4">
              <button
                onClick={handleOrdersClick}
                className="bg-emerald-800 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg font-medium shadow-sm transition text-left"
              >
                Orders
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header